import { DeviceInfo, LotteryMenuHeader } from 'models/commonModel';
import { RandomPickOption } from 'models/lotteryModel';

export const DEVICE_INFO: DeviceInfo = {
    uuid: '',
    timezone: '',
    platform: '',
    resolution: '',
};

export const ltOpenDay = [
    '202,203,204,200,206,123,124,125,139,131,201',
    '202,203,204,200,206,105,106,107,126,127,201',
    '202,203,204,200,206,109,110,128,129,201', // 108
    '202,203,204,200,206,111,112,113,130,131,201',
    '202,203,204,200,206,114,115,116,132,133,134,201',
    '202,203,204,200,206,117,118,119,135,136,201',
    '202,203,204,200,206,105,121,122,137,138,130,201', // 120
];

export const lotteryHeaderMenu: LotteryMenuHeader[] = [
    {
        title: 'Xổ số Livestream',
        isFilterDate: false,
        type: 'FAST',
        child: [{ ltid: 0, label: 'Livestream 2 phút' }],
    },
    {
        title: 'Mega 6/45',
        isFilterDate: false,
        type: 'FAST',
        child: [
            { ltid: 0, label: '1 Giây' },
            { ltid: 0, label: '1 Phút' },
        ],
    },
    {
        title: 'siêu tốc',
        isFilterDate: false,
        type: 'FAST',
        child: [
            { ltid: 50, label: 'Siêu Tốc 1 Giây' },
            { ltid: 100, label: 'Siêu Tốc 45 Giây' },
            { ltid: 101, label: 'Siêu Tốc 1 Phút' },
            { ltid: 102, label: 'Siêu Tốc 1.5 Phút' },
            { ltid: 103, label: 'Siêu Tốc 2 Phút' },
            { ltid: 104, label: 'Siêu Tốc 5 Phút' },
        ],
    },
    // {
    //     title: 'Siêu tốc miền Bắc',
    //     isFilterDate: false,
    //     type: 'FAST',
    //     child: [
    //         { ltid: 140, label: 'Miền Bắc 1 Giây' },
    //         { ltid: 141, label: 'Miền Bắc 45 Giây' },
    //         { ltid: 142, label: 'Miền Bắc 1 Phút' },
    //         { ltid: 143, label: 'Miền Bắc 1.5 Phút' },
    //         { ltid: 144, label: 'Miền Bắc 2 Phút' },
    //         { ltid: 145, label: 'Miền Bắc 5 Phút' },
    //     ],
    // },

    {
        title: 'miền Nam',
        isFilterDate: true,
        type: 'MN',
        child: [
            { label: 'Xổ Số Tiền Giang', ltid: 123, openDay: 0 },
            { label: 'Xổ Số Kiên Giang', ltid: 124, openDay: 0 },
            { label: 'Xổ Số Đà Lạt', ltid: 125, openDay: 0 },
            { label: 'Xổ Số Hồ Chí Minh', ltid: 105, openDay: 1 },
            { label: 'Xổ Số Đồng Tháp', ltid: 106, openDay: 1 },
            { label: 'Xổ Số Cà Mau', ltid: 107, openDay: 1 },
            { label: 'Xổ Số Vũng Tàu', ltid: 109, openDay: 2 },
            { label: 'Xổ Số Bạc Liêu', ltid: 110, openDay: 2 },
            { label: 'Xổ Số Đồng Nai', ltid: 111, openDay: 3 },
            { label: 'Xổ Số Cần Thơ', ltid: 112, openDay: 3 },
            { label: 'Xổ Số Sóc Trăng', ltid: 113, openDay: 3 },
            { label: 'Xổ Số Tây Ninh', ltid: 114, openDay: 4 },
            { label: 'Xổ Số An Giang', ltid: 115, openDay: 4 },
            { label: 'Xổ Số Bình Thuận', ltid: 116, openDay: 4 },
            { label: 'Xổ Số Vĩnh Long', ltid: 117, openDay: 5 },
            { label: 'Xổ Số Bình Dương', ltid: 118, openDay: 5 },
            { label: 'Xổ Số Trà Vinh', ltid: 119, openDay: 5 },
            { label: 'Xổ Số Hồ Chí Minh', ltid: 105, openDay: 6 },
            { label: 'Xổ Số Bình Phước', ltid: 121, openDay: 6 },
            { label: 'Xổ Số Hậu Giang', ltid: 122, openDay: 6 },
        ],
    },
    {
        title: 'miền Trung',
        isFilterDate: true,
        type: 'MT',
        child: [
            { label: 'Xổ Số Huế', ltid: 126, openDay: 0 },
            { label: 'Xổ Số Kon Tum', ltid: 139, openDay: 0 },
            { label: 'Xổ Số Khánh Hoà', ltid: 131, openDay: 0 },

            { label: 'Xổ Số Huế', ltid: 126, openDay: 1 },
            { label: 'Xổ Số Phú Yên', ltid: 127, openDay: 1 },

            { label: 'Xổ Số Đắk Lắk', ltid: 128, openDay: 2 },
            { label: 'Xổ Số Quảng Nam', ltid: 129, openDay: 2 },

            { label: 'Xổ Số Đà Nẵng', ltid: 130, openDay: 3 },
            { label: 'Xổ Số Khánh Hoà', ltid: 131, openDay: 3 },

            { label: 'Xổ Số Bình Định', ltid: 132, openDay: 4 },
            { label: 'Xổ Số Quảng Trị', ltid: 133, openDay: 4 },
            { label: 'Xổ Số Quảng Bình', ltid: 134, openDay: 4 },

            { label: 'Xổ Số Gia Lai', ltid: 135, openDay: 5 },
            { label: 'Xổ Số Ninh Thuận', ltid: 136, openDay: 5 },

            { label: 'Xổ Số Quảng Ngãi', ltid: 137, openDay: 6 },
            { label: 'Xổ Số Đắc Nông', ltid: 138, openDay: 6 },
            { label: 'Xổ Số Đà Nẵng', ltid: 130, openDay: 6 },
        ],
    },
    {
        title: 'miền Bắc',
        isFilterDate: false,
        type: 'MB',
        child: [
            { ltid: 200, label: 'Xổ Số Miền Bắc' },
            { ltid: 201, label: 'Đặc Biệt 18h25' },
        ],
    },
    {
        title: 'Xổ số vip',
        isFilterDate: false,
        type: 'FAST',
        child: [
            { ltid: 205, label: 'Sài gòn vip 15h15' },
            { ltid: 203, label: 'HCM vip 16h15' },
            { ltid: 204, label: 'Đà nẵng vip 17h15' },
            { ltid: 202, label: 'Hà nội vip 19h15' },
            { ltid: 208, label: 'thủ đô vip 21h15' },
        ],
    },
];

export const listHeaderMenuCopy = [
    { key: '/' },
    { key: '/lottery' },
    {
        key: '_____',
        name: 'Dân gian',
        child: [
            { ltid: 0, image: require('assets/images/list-game/tai_xiu.png'), child: [{ title: '1 Giây', ltid: 0 }, { title: '1 Phút' }], isHot: false },
            { ltid: 0, image: require('assets/images/list-game/xoc_dia.png'), child: [{ title: '1 Giây' }, { title: '1 Phút' }] },
            { ltid: 0, image: require('assets/images/list-game/bau_cua.png'), child: [{ title: '1 Giây' }, { title: '1 Phút' }] },
            { ltid: 0, image: require('assets/images/list-game/tu_ti.png'), child: [{ title: '1 Giây' }] },
            { ltid: 0, image: require('assets/images/list-game/con_giap.png'), child: [{ title: '1 Giây' }, { title: '1 Phút' }] },
        ],
    },
    {
        key: 'SB',
        child: [
            { name: 'BTi', gametype: 'SB', providercode: 'BT', image: require('assets/images/list-game/bti.png') },
            { image: require('assets/images/list-game/ap-sports.png') },
            { name: 'SBObet', gametype: 'SB', providercode: 'SBO', image: require('assets/images/list-game/sbobet.png') },
            { name: 'IBCbet', gametype: 'SB', providercode: 'IBC', image: require('assets/images/list-game/ibcbet.png'), category: 'SPORT_BOOK' },
            { name: 'IBC E-sport', gametype: 'SB', providercode: 'IBC', image: require('assets/images/list-game/ibc_esport.png') },
            { image: require('assets/images/list-game/ap-sports2.png') },
            { name: 'CMD', gametype: 'SB', providercode: 'CM', image: require('assets/images/list-game/cmd368.png') },
            { name: 'TF Gaming', gametype: 'SB', providercode: 'TF', image: require('assets/images/list-game/tf-sports.png') },
            // { name: 'SABA', gametype: 'SB', providercode: 'IB' },
        ],
    },
    {
        key: 'SL',
        child: [
            { name: 'TOTO game', gametype: 'SL', providercode: 'TOTO', image: require('assets/images/list-game/toto.png') },
            { name: 'SKYWIND', gametype: 'SL', providercode: 'SW', image: require('assets/images/list-game/sky_wind.png') },
            { name: '5G Games', gametype: 'SL', providercode: '5G', image: require('assets/images/list-game/5g-logo.png') },
            { name: 'YGR', gametype: 'SL', providercode: 'YGR', image: require('assets/images/list-game/ygr-logo.png') },
            { name: 'HABANERO', gametype: 'SL', providercode: 'HB', image: require('assets/images/list-game/habanero.png') },
            { name: 'Play Tech', gametype: 'SL', providercode: 'PT', image: require('assets/images/list-game/play_tech.png') },
            { name: 'Dragon Soft', gametype: 'SL', providercode: 'DS', image: require('assets/images/list-game/dragoon.png') },
            { name: 'Pragmatic Play', gametype: 'SL', providercode: 'PR', image: require('assets/images/list-game/ppgame.png') },
            // { name: 'BBin', gametype: 'SL', providercode: 'BB' },
            // { name: 'CQ9', gametype: 'SL', providercode: 'CQ' },
            // { name: 'PGSOFT', gametype: 'SL', providercode: 'PG' },
            // { name: 'Rich88', gametype: 'SL', providercode: 'R8' },
        ],
    },
    {
        key: 'OT',
        name: 'Trò Chơi',
        child: [{ name: 'Đá Gà', gametype: 'OT', providercode: 'DAGA', image: require('assets/images/list-game/da_ga.png') }],
    },
    {
        key: 'LC',
        child: [
            { name: 'DREAM GAMING', gametype: 'LC', providercode: 'DG', image: require('assets/images/list-game/dream-gaming.png') },
            { name: 'SEXY GAMING', gametype: 'LC', providercode: 'SEXY', image: require('assets/images/list-game/sexy-gaming.png') },
            { name: 'EVOLUTION GAMING', gametype: 'LC', providercode: 'E0', image: require('assets/images/list-game/evolution.png') },
            { image: require('assets/images/list-game/sexy-game.png') },
            { name: 'WM CASINO', gametype: 'LC', providercode: 'WC', image: require('assets/images/list-game/casino_live.png') },
            { image: require('assets/images/list-game/peta.png') },
            { image: require('assets/images/list-game/luck.o.AI.png') },
            { name: 'PLAY ACE', gametype: 'LC', providercode: 'AG', image: require('assets/images/list-game/play-ace.png') },
            // { name: 'WORLD Entertainment', gametype: 'LC', providercode: 'WE' },
            // { name: 'BBin', gametype: 'LC', providercode: 'BB' },
            // { name: 'Pragmatic BLACKJACK', gametype: 'LC', providercode: 'PR' },
            // { name: 'Pragmatic Play', gametype: 'LC', providercode: 'PR' },
        ],
    },
    {
        key: 'CB',
        child: [
            { name: 'V8', gametype: 'CB', providercode: 'V8', image: require('assets/images/list-game/v8_poker.png') },
            { name: 'BOLE', gametype: 'CB', providercode: 'BOLE', image: require('assets/images/list-game/bole.png') },
            // { name: 'KAIYUAN GAMING', gametype: 'CB', providercode: 'KY' },
        ],
    },
    {
        key: 'FH',
        child: [
            { name: 'YGR', gametype: 'FH', providercode: 'YGR', image: require('assets/images/list-game/ygr-fishing-logo.png') },
            { name: 'DS', gametype: 'FH', providercode: 'DS', image: require('assets/images/list-game/ds.png') },
            // { name: 'CQ9', gametype: 'FH', providercode: 'C9' },
            // { name: 'JILI', gametype: 'FH', providercode: 'JA' },
        ],
    },
    { key: '/promotion' },
];

export const dataWinMORE = [
    { username: 's88***', game: 'Xổ Số Truyền Thống', prize: '6,288,775,100' },
    { username: 'ganhnh***', game: 'Xổ Số VIP', prize: '5,866,355,000' },
    { username: 'trungha***', game: 'Xổ Số Nhanh', prize: '5,538,713,000' },
    { username: 'namviet***', game: 'IBC Sport', prize: '4,699,244,000' },
    { username: 'hoangho***', game: 'Xổ Số Truyền Thống', prize: '4,255,711,000' },
    { username: 'damon***', game: 'Xổ Số Nhanh', prize: '3,877,452,300' },
    { username: 'vuvan*****', game: 'Xổ Số VIP', prize: '3,433,611,000' },
    { username: 'vuduc*****', game: 'CMD Sports Book', prize: '3,089,325,000' },
    { username: 'natha*****', game: 'Xổ Số Truyền Thống', prize: '2,867,555,500' },
    { username: 'luuma*****', game: 'Xổ Số VIP', prize: '2,544,335,000' },
    { username: '09883*****', game: 'WM Casino', prize: '2,388,266,000' },
    { username: 'lanna*****', game: 'EBET (Live Casino)', prize: '1,772,566,000' },
    { username: 'thano*****', game: 'Xổ Số Nhanh', prize: '1,588,311,000' },
    { username: '09785*****', game: 'Xổ Số Truyền Thống', prize: '981,500,000' },
    { username: 'hoand*****', game: 'Mega Siêu tốc 6/45', prize: '953,761,300' },
    { username: 'azira*****', game: 'Xổ Số VIP', prize: '886,455,000' },
    { username: 'truta*****', game: 'Asia Gaming', prize: '838,711,000' },
    { username: 'chiwe*****', game: 'TD Skywind', prize: '790,115,377' },
    { username: 'cukki*****', game: 'Tài Xỉu', prize: '755,338,120' },
    { username: 'tienv*****', game: 'Xóc Đĩa', prize: '695,366,150' },
];

export const dataWinBIG = [
    { username: 'ANTON*****', game: 'XỔ SỐ TRUYỀN THỐNG', prize: '9,188,652,000' },
    { username: 'XEKAN*****', game: 'XỔ SỐ NHANH', prize: '8,266,321,000' },
    { username: 'DANTE*****', game: 'XỔ SỐ VIP', prize: '7,890,455,000' },
    { username: 'TRANT*****', game: 'IBC SPORT', prize: '6,868,392,000' },
    { username: 'VUDUC*****', game: 'XỔ SỐ TRUYỀN THỐNG', prize: '6,557,623,000' },
    { username: 'TRAME*****', game: 'XỔ SỐ NHANH', prize: '5,590,711,000' },
    { username: 'haduk*****', game: 'Xổ Số VIP', prize: '5,286,324,100' },
    { username: '09826*****	', game: 'CMD Sports Book', prize: '4,755,860,000' },
    { username: 'sheva*****', game: 'Xổ Số Truyền Thống', prize: '4,588,562,000' },
    { username: 'larkel*****', game: 'WM Casino', prize: '4,322,690,150' },
    { username: 'levis*****', game: 'Xổ Số Nhanh', prize: '3,711,552,000' },
    { username: 'oton*****', game: 'Xổ Số VIP', prize: '3,358,991,000' },
    { username: 'marve*****', game: 'EBET (Live Casino)', prize: '3,117,089,000' },
    { username: '08688*****', game: 'Xổ Số Truyền Thống', prize: '2,896,721,300' },
    { username: 'nekos*****', game: 'Xổ Số Nhanh', prize: '2,544,863,000' },
    { username: 'harit*****', game: 'Asia Gaming', prize: '2,066,599,500' },
    { username: '08793*****', game: 'Mega Siêu tốc 6/45', prize: '1,866,321,100' },
    { username: 'akira*****', game: 'Tài Xỉu', prize: '1,525,810,000' },
    { username: 'lanna*****', game: 'Xóc Đĩa', prize: '1,055,936,000' },
    { username: '09888*****', game: 'HABA (Slot Game)', prize: '869,416,000' },
];

export const bannerList = [
    { id: 1, photourl: require('assets/images/banner-home/1.png') },
    { id: 2, photourl: require('assets/images/banner-home/2.png') },
    { id: 3, photourl: require('assets/images/banner-home/3.png') },
    { id: 4, photourl: require('assets/images/banner-home/4.png') },
    { id: 5, photourl: require('assets/images/banner-home/5.png') },
    { id: 6, photourl: require('assets/images/banner-home/6.png') },
    { id: 7, photourl: require('assets/images/banner-home/7.png') },
    { id: 8, photourl: require('assets/images/banner-home/8.png') },
    { id: 9, photourl: require('assets/images/banner-home/9.png') },
    { id: 10, photourl: require('assets/images/banner-home/10.png') },
    { id: 11, photourl: require('assets/images/banner-home/11.png') },
    { id: 12, photourl: require('assets/images/banner-home/12.png') },
    { id: 13, photourl: require('assets/images/banner-home/13.png') },
    { id: 14, photourl: require('assets/images/banner-home/14.png') },
    { id: 15, photourl: require('assets/images/banner-home/15.png') },
    { id: 16, photourl: require('assets/images/banner-home/16.png') },
    { id: 17, photourl: require('assets/images/banner-home/17.png') },
    { id: 18, photourl: require('assets/images/banner-home/18.png') },
    { id: 19, photourl: require('assets/images/banner-home/19.png') },
    { id: 20, photourl: require('assets/images/banner-home/20.png') },
    { id: 21, photourl: require('assets/images/banner-home/21.png') },
    { id: 22, photourl: require('assets/images/banner-home/22.png') },
];

export const listGameST: { img: any; ltid?: number }[] = [
    { img: require('assets/images/list-game/livesteam-2-phut.png') },
    { img: require('assets/images/list-game/sieu-toc-1-giay.png'), ltid: 50 },
    { img: require('assets/images/list-game/sieu-toc-45-giay.png'), ltid: 100 },
    { img: require('assets/images/list-game/sieu-toc-1-phut.png'), ltid: 101 },
    { img: require('assets/images/list-game/sieu-toc-1-5-phut.png'), ltid: 102 },
    { img: require('assets/images/list-game/sieu-toc-2-phut.png'), ltid: 103 },
    { img: require('assets/images/list-game/sieu-toc-5-phut.png'), ltid: 104 },
    { img: require('assets/images/list-game/mega-1s.png') },
    { img: require('assets/images/list-game/mega-1m.png') },
];

export const listGameDG: { img: any; ltid?: number }[] = [
    { img: require('assets/images/list-game-dg/tai-xiu-1s.png') },
    { img: require('assets/images/list-game-dg/tai-xiu-1m.png') },
    { img: require('assets/images/list-game-dg/xoc-dia-1s.png') },
    { img: require('assets/images/list-game-dg/xoc-dia-1m.png') },
    { img: require('assets/images/list-game-dg/bau-cua-1s.png') },
    { img: require('assets/images/list-game-dg/bau-cua-1m.png') },
    { img: require('assets/images/list-game-dg/oan-tu-ti.png') },
    { img: require('assets/images/list-game-dg/12-con-giap-1s.png') },
    { img: require('assets/images/list-game-dg/12-con-giap-1p.png') },
];
export const listGameXS: { img: any; ltid?: number }[] = [
    { img: require('assets/images/list-game-xs/ha-noi-vip.png') },
    { img: require('assets/images/list-game-xs/mien-bac.png'), ltid: 200 },
    { img: require('assets/images/list-game-xs/18h25.png'), ltid: 201 },
    { img: require('assets/images/list-game-xs/hue.png'), ltid: 126 },
    { img: require('assets/images/list-game-xs/phu-yen.png'), ltid: 127 },
    { img: require('assets/images/list-game-xs/ho-chi-minh.png'), ltid: 105 },
    { img: require('assets/images/list-game-xs/dong-thap.png'), ltid: 106 },
    { img: require('assets/images/list-game-xs/ca-mau.png'), ltid: 107 },
];

const sprite = require('assets/images/game-footer/footer-game.png');

export const gameFooter = [
    [
        { sprite, posY: 0, gametype: 'SB', providercode: 'IBC' }, // IBC
        { sprite, posY: -140, gametype: 'SB', providercode: 'CM' }, // CMD
        { sprite, posY: -280, gametype: 'SB', providercode: 'BT' }, // BTi
        { sprite, posY: -420 }, // APsports
    ],
    [
        { sprite, posY: -560 }, // Sexy
        { sprite, posY: -700, gametype: 'LC', providercode: 'WC' }, // WM Casino
        { sprite, posY: -840, gametype: 'LC', providercode: 'E0' }, // Evolution (FX)
        { sprite, posY: -980 }, // eBET
    ],
    [
        { sprite, posY: -1120, gametype: 'SL', providercode: 'PR' }, // Pragmatic
        { sprite, posY: -1260, gametype: 'SL', providercode: 'HB' }, // Habanero
        { sprite, posY: -1400, gametype: 'FH', providercode: 'YGR' }, // YGR
        { sprite, posY: -1540, gametype: 'CB', providercode: 'V8' }, // V8Poker
    ],
];

export const suggestXS: RandomPickOption[] = [
    { title: 'Kép bằng', randomAmount: 111, countNumAsOne: 1, value: '00;11;22;33;44;55;66;77;88;99;' },
    {
        title: 'Chẵn',
        randomAmount: 222,
        countNumAsOne: 1,
        value: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;',
    },
    {
        title: 'Lẻ',
        randomAmount: 333,
        countNumAsOne: 1,
        value: '01;03;05;07;09;11;13;15;17;19;21;23;25;27;29;31;33;35;37;39;41;43;45;47;49;51;53;55;57;59;61;63;65;67;69;71;73;75;77;79;81;83;85;87;89;91;93;95;97;99;',
    },
    {
        title: 'Lớn',
        randomAmount: 444,
        countNumAsOne: 1,
        value: '50;51;52;53;54;55;56;57;58;59;60;61;62;63;64;65;66;67;68;69;70;71;72;73;74;75;76;77;78;79;80;81;82;83;84;85;86;87;88;89;90;91;92;93;94;95;96;97;98;99;',
    },
    {
        title: 'Nhỏ',
        randomAmount: 555,
        countNumAsOne: 1,
        value: '00;01;02;03;04;05;06;07;08;09;10;11;12;13;14;15;16;17;18;19;20;21;22;23;24;25;26;27;28;29;30;31;32;33;34;35;36;37;38;39;40;41;42;43;44;45;46;47;48;49;',
    },
];

export const suggestXS2: RandomPickOption[] = [
    { title: 'Top 1', randomAmount: 11, key: 'none_1', countNumAsOne: 1 },
    { title: 'Top 2', randomAmount: 22, key: 'none_2', countNumAsOne: 1 },
    { title: 'Top 5', randomAmount: 33, key: 'none_5', countNumAsOne: 1 },
    { title: 'Top 10', randomAmount: 44, key: 'none_10', countNumAsOne: 1 },
    { title: 'Top 20', randomAmount: 55, key: 'none_20', countNumAsOne: 1 },
];

export const KEY_HASH = '9364b12c11bb71d0cdfdaece69c90aedb4387f695dbd635d4a8fec2b3c9836f0';

export const REG_SECRET_KEY = 'd8f5001db7ca24a1eaf79ec743d8df4306ae3de6d12c24f6bfa5157fbda657f6';

export const DEFAULT_OG_IMAGE = 'https://vuibet.app/assets/images/social.png';

export const PHONE_VERIFY_URL = 'https://verify.xsltviet.com';

export const SUPPORT_LINKS = {
    SPEEDTEST: 'https://alb88.online/',
    TELEGRAM_DL: 'https://t.me/loto188info',
    TELEGRAM_CS: 'https://t.me/vnloto188',
    MAIL: 'customerserviceloto188@gmail.com',
    FACEBOOK: 'https://facebook.com/loto188bet',
    YOUTUBE: 'https://www.youtube.com/@LOTO188-r8k',
};
